var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#3659B2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 11.3335L8.33333 8.3335H15.6667L16.6667 11.3335M15.6667 14.6668C15.4015 14.6668 15.1471 14.5615 14.9596 14.3739C14.772 14.1864 14.6667 13.932 14.6667 13.6668C14.6667 13.4016 14.772 13.1473 14.9596 12.9597C15.1471 12.7722 15.4015 12.6668 15.6667 12.6668C15.9319 12.6668 16.1862 12.7722 16.3738 12.9597C16.5613 13.1473 16.6667 13.4016 16.6667 13.6668C16.6667 13.932 16.5613 14.1864 16.3738 14.3739C16.1862 14.5615 15.9319 14.6668 15.6667 14.6668ZM8.33333 14.6668C8.06812 14.6668 7.81376 14.5615 7.62623 14.3739C7.43869 14.1864 7.33333 13.932 7.33333 13.6668C7.33333 13.4016 7.43869 13.1473 7.62623 12.9597C7.81376 12.7722 8.06812 12.6668 8.33333 12.6668C8.59855 12.6668 8.8529 12.7722 9.04044 12.9597C9.22798 13.1473 9.33333 13.4016 9.33333 13.6668C9.33333 13.932 9.22798 14.1864 9.04044 14.3739C8.8529 14.5615 8.59855 14.6668 8.33333 14.6668ZM16.6133 8.00016C16.48 7.6135 16.1067 7.3335 15.6667 7.3335H8.33333C7.89333 7.3335 7.52 7.6135 7.38667 8.00016L6 12.0002V17.3335C6 17.5103 6.07024 17.6799 6.19526 17.8049C6.32029 17.9299 6.48986 18.0002 6.66667 18.0002H7.33333C7.51014 18.0002 7.67971 17.9299 7.80474 17.8049C7.92976 17.6799 8 17.5103 8 17.3335V16.6668H16V17.3335C16 17.5103 16.0702 17.6799 16.1953 17.8049C16.3203 17.9299 16.4899 18.0002 16.6667 18.0002H17.3333C17.5101 18.0002 17.6797 17.9299 17.8047 17.8049C17.9298 17.6799 18 17.5103 18 17.3335V12.0002L16.6133 8.00016Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoint);
export default __webpack_public_path__ + "static/media/point.34ee243edbbf8bf088b4fc6f63cf2a41.svg";
export { ForwardRef as ReactComponent };